import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { Divider } from '../../Divider';
export const Placeholder = ({ style, fluid, compact }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, fluid ? styles.fluid : null, style] },
        React.createElement(View, { style: styles.subject }),
        React.createElement(View, { style: styles.date }),
        !compact && (React.createElement(View, { style: styles.participantsContainer },
            React.createElement(View, { style: styles.participantsIcon }),
            React.createElement(View, { style: styles.participants }))),
        React.createElement(Divider, { style: styles.divider, type: 'horizontal' }),
        React.createElement(View, { style: styles.footer })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    fluid: { flex: 1 },
    container: {
        padding: size.G,
        justifyContent: 'space-between',
        backgroundColor: color.invert2.p4,
        borderRadius: 16,
        width: 275
    },
    subject: {
        backgroundColor: color.invert2.p4,
        borderRadius: 6,
        width: '60%',
        height: size.I
    },
    date: {
        backgroundColor: color.invert2.p4,
        borderRadius: 6,
        width: '80%',
        marginTop: size.C,
        height: size.I
    },
    participantsContainer: {
        marginTop: size.G,
        flexDirection: 'row',
        alignItems: 'center'
    },
    participantsIcon: {
        backgroundColor: color.invert2.p4,
        borderRadius: 6,
        width: size.J,
        height: size.J,
        marginRight: size.C
    },
    participants: {
        height: size.G,
        width: '40%',
        backgroundColor: color.invert2.p4,
        borderRadius: 6
    },
    divider: {
        marginTop: size.G
    },
    footer: {
        marginTop: size.G,
        backgroundColor: color.invert2.p4,
        borderRadius: 6,
        width: '50%',
        height: size.H
    }
}));
//# sourceMappingURL=Placeholder.js.map